import { useCatalogProductIdParams, usePdpBaseInfo } from '@domains/pdp-common';

export const useCouponBannerService = () => {
  const params = useCatalogProductIdParams();
  const {
    product: { top_summary_notice_text },
  } = usePdpBaseInfo(params);

  return {
    noticeText: top_summary_notice_text,
  };
};
